<template>
  <transition-group
    tag="ul"
    :class="[
      'poi-upload-list',
      'poi-upload-list--' + listType,
      { 'is-disabled': disabled }
    ]"
    name="el-list"
  >
    <li
      v-for="file in files"
      :class="['poi-upload-list__item', 'is-' + file.status, focusing ? 'focusing' : '']"
      :key="file.uid"
      tabindex="0"
      @keydown.delete="!disabled && $emit('remove', file)"
      @focus="focusing = true"
      @blur="focusing = false"
      @click="focusing = false"
    >
      <img
        class="poi-upload-list__item-thumbnail"
        v-if="file.status !== 'uploading' && ['picture-card', 'picture'].indexOf(listType) > -1"
        :src="file.url" alt=""
      >
      <a class="poi-upload-list__item-name" @click="handleClick(file)">
        <i class="iconfont poi-icon-document"></i>{{file.name}}
      </a>
      <label class="poi-upload-list__item-status-label">
        <i class="iconfont" :class="{
          'poi-icon-upload-success': true,
          'poi-icon-circle-check': listType === 'text',
          'poi-icon-check': ['picture-card', 'picture'].indexOf(listType) > -1
        }"></i>
      </label>
      <i class="iconfont poi-icon-close2" v-if="!disabled" @click="$emit('remove', file)"></i>
      <!-- <i class="poi-icon-close-tip" v-if="!disabled">{{ t('el.upload.deleteTip') }}</i> 因为close按钮只在li:focus的时候 display, li blur后就不存在了，所以键盘导航时永远无法 focus到 close按钮上 -->
      <!-- <i class="poi-icon-close-tip" v-if="!disabled">{{ t('el.upload.deleteTip') }}</i>  -->
      <i class="iconfont poi-icon-tip" v-if="!disabled" @click="closeAction" v-show="false">×</i> 
      <!--因为close按钮只在li:focus的时候 display, li blur后就不存在了，所以键盘导航时永远无法 focus到 close按钮上-->
      <poi-progress
        v-if="file.status === 'uploading'"
        :type="listType === 'picture-card' ? 'circle' : 'line'"
        :stroke-width="listType === 'picture-card' ? 6 : 2"
        :percentage="parsePercentage(file.percentage)">
      </poi-progress>
      <span class="poi-upload-list__item-actions" v-if="listType === 'picture-card'">
        <span
          class="poi-upload-list__item-preview"
          v-if="handlePreview && listType === 'picture-card'"
          @click="handlePreview(file)"
        >
          <i class="iconfont poi-icon-zoom-in"></i>
        </span>
        <span
          v-if="!disabled"
          class="poi-upload-list__item-delete"
          @click="$emit('remove', file)"
        >
          <i class="iconfont poi-icon-delete"></i>
        </span>
      </span>
    </li>
  </transition-group>
</template>
<script>
  // import Locale from 'element-ui/src/mixins/locale';
  import Locale from './../../../../assets/js/locale';
  // import ElProgress from './progress';

  export default {

    name: 'ElUploadList',

    mixins: [Locale],

    data() {
      return {
        focusing: false
      };
    },
    // components: { ElProgress },
    // components: {  },

    props: {
      files: {
        type: Array,
        default() {
          return [];
        }
      },
      disabled: {
        type: Boolean,
        default: false
      },
      handlePreview: Function,
      listType: String
    },
    methods: {
      parsePercentage(val) {
        return parseInt(val, 10);
      },
      handleClick(file) {
        this.handlePreview && this.handlePreview(file);
      },
      closeAction(){
        // t('el.upload.deleteTip')
      }
    }
  };
</script>